var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { extendTailwindMerge } from 'tailwind-merge';
import tailwindConfig from '../../tailwind.marketing.config';
var twMerge = extendTailwindMerge({
    extend: {
        theme: {
            spacing: Object.keys(tailwindConfig.theme.extend.spacing),
        },
    },
});
var TWMergeContext = createContext(undefined);
export var TWMergeProvider = function (_a) {
    var children = _a.children;
    return _jsx(TWMergeContext.Provider, __assign({ value: { twMerge: twMerge } }, { children: children }));
};
export var useTWMergeContext = function () {
    var context = useContext(TWMergeContext);
    if (!context) {
        throw new Error('useTWMergeContext must be used within a TWContextProvider');
    }
    return context;
};
